<template>
  <div id="instrument-verification">
    <div style="margin-bottom: 10px">
      <el-button  @click="openEditDialog" style="width: 150px" >选择设备</el-button>
    </div>
    <el-tabs type="card" >
      <el-tab-pane label="基础信息" >
        <el-descriptions :column="4" style="margin-left: 15px;">
          <el-descriptions-item label="仪器名称">
            <el-tag size="small">{{ machine.name || '空'}}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="内部编号">
            <el-tag size="small">{{ machine.machineNO || '空'  }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="新内部编号">
            <el-tag size="small">{{ machine.newMachineNO || '空' }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="型号/规格">{{ machine.specs }}</el-descriptions-item>
          <el-descriptions-item label="机身号码">{{ machine.serialNO }}</el-descriptions-item>
          <el-descriptions-item label="检定日期">
            {{ $util.formatDate(machine.verificationDate) || '空' }}
          </el-descriptions-item>
          <el-descriptions-item label="检定有效日期">{{ $util.formatDate(machine.verificationValidDate) }}</el-descriptions-item>
        </el-descriptions>
      </el-tab-pane>
    </el-tabs>

    <account type="计量录入" :machine="machine"></account>
  </div>
</template>

<script>
import AccountComponent from '@/components/instrument/AccountComponent.vue'
export default {
  name: 'instrument-verification',
  components: {
    'account': AccountComponent
  },
  data() {
    return {
      machine: {},
    }
  },
  mounted(){
    
  },
  methods: {
    openEditDialog(){
      let that = this.$root.$children[0].$children[1].$children[0];
      that.selectDialogVisible = true;
      that.$set(that,'childrenObject',this);
    },
  }
}
</script>
<style>
html,body{
  margin: 0;
  height: 100%;
}
#instrument-verification{
  position: relative;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/instrument/Verification.vue